import { gql } from '@apollo/client'

export const UPDATE_GLOBAL_PROJECT = gql`
  mutation ($input: CampaignUpdate) {
    updateGlobalCampaign(input: $input) {
      id
      info
      team_info
      campaign_id
      global_status
      isaac_url {
        title
        url
      }
      created_at
      __typename
    }
  }
`
